import React from 'react';
import ReservationEditButtons from '../ReservationEditButtons/ReservationEditButtons';

function ReservationListItem(props) {

    const monthDayFormat = (number) => {
        return number > 9 ? "" + number : "0" + number;
    };

    const startDate = monthDayFormat(props.startDate[2]) + ". " + monthDayFormat(props.startDate[1]) + ". " + props.startDate[0] + ".";
    const endDate = monthDayFormat(props.endDate[2]) + ". " + monthDayFormat(props.endDate[1]) + ". " + props.endDate[0] + ".";

    const isValid = () => {
        let user = JSON.parse(localStorage.getItem('user'));
        console.log(user);
        return (user.role === "ROLE_ADMINISTRATOR");
    }
    return (
        <tr className="table-cell">

            { isValid() ?
                <td>{props.guestName}</td> :""
            }
            <td>{startDate} - {endDate}</td>

            {props.isHotelDetails ? "":
                <td>
                    <ReservationEditButtons
                        id={props.id}
                        guestName={props.guestName}
                        startDate={props.startDate}
                        endDate={props.endDate}
                        reservationEdit={props.reservationEdit}
                        deleteHandler={props.deleteHandler}
                        userName={props.guestName}
                    />
                </td>
            }
        </tr>
    )
}

export default ReservationListItem;


// WEBPACK FOOTER //
// ./src/components/ReservationListItem/ReservationListItem.jsx